let lastFocusedElement = document.activeElement

const trapFocus = (container, lastFocused) => {
  const elements =
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'

    if (!container) {
    lastFocused.focus()
    return
  }

  let focusableContent = container.querySelectorAll(elements)
  let firstFocusableElement = focusableContent[0]
  let lastFocusableElement = focusableContent[focusableContent.length - 1]
  let isHandleKeydownEventSet = false

  const handleKeydown = (e) => {
    // Cashing all of the focusable elements on click, because of dynamic content
    focusableContent = container.querySelectorAll(elements)
    firstFocusableElement = focusableContent[0]
    lastFocusableElement = focusableContent[focusableContent.length - 1]

    if (e.key !== 'Tab') {
      return
    }

    if (e.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement?.focus()
        e.preventDefault()
      }
    } else {
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement?.focus()
        e.preventDefault()
      }
    }
  }

  if (lastFocused) {
    lastFocused.focus()
  } else {
    if (!isHandleKeydownEventSet) {
      document.addEventListener('keydown', handleKeydown)

      isHandleKeydownEventSet = true
    }

    setTimeout(() => {
      firstFocusableElement?.focus()
    }, 400)
  }
}

// Variant modal slider index
var slideIndex = 1;

var recurateModal = (function($) {
  $body = $('body');
  var init = function() {
    // cache body selector
    $body = $('body');
  };

  var toggleModal = function(id) {
    // toggle classes
    if($body.hasClass('recurate-body-modal-open')) {
      close(id);
    } else {
      show(id);
    }
  };

  var show = function(id, trigger) {
    // add modal open class
    $body.addClass('recurate-body-modal-open');

    // set timeout for active class to allow css animation
    setTimeout(function() {
      $(id).addClass('recurate-modal-active');
      if($(id + " .rec-var-images-modal").hasClass("rec-slider")) {
        $(id + " .rec-var-images-modal").slick("setPosition");
        $(id + " .rec-var-images-modal").addClass("slick-loaded");
      }
    },25);

    lastFocusedElement = trigger

    trapFocus($(id).get(0))
  }

  var close = function(id) {
    // remove modal open class
    $body.removeClass('recurate-body-modal-open');
    // set timeout for active class to allow css animation
    setTimeout(function() {
      $('.recurate-modal').removeClass('recurate-modal-active');
    },25);
    // reset the slide index
    slideIndex = 1;

    trapFocus($(id).get(0), lastFocusedElement)
  };

  return {
    init: init,
    toggleModal: toggleModal,
    show: show,
    close: close
  };
}($rec));

//Custom JS Functionality
Shopify.queryParams = Shopify.queryParams || {};
if (Object.keys(Shopify.queryParams).length == 0 && location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
(function($) {

  var recurateVariantListInit = function() {

    $(document).keyup(function(e) {
      if (e.key === "Escape" && $("body.recurate-body-modal-open").length > 0) {
        recurateModal.close("");
     }
    });
    $("body").on("click",".recurate-modal-toggle", function(e) {
      e.preventDefault();
      recurateModal.toggleModal($(this).data("recurateModal"));
    });
    $("body").on("click",".recurate-modal-show", function(e) {
      e.preventDefault();
      recurateModal.show($(this).data("recurateModal"), e.target);
    });
    $("body").on("click",".recurate-modal-close", function(e) {
      e.preventDefault();
      recurateModal.close("");
    });
    $("body").on("click",".rec-condition-description-toggler", function(e) {
      $(this).closest(".rec-var-option").children(".rec-condition-description-toggle").toggle();
    });

    var slidersInit = function() {
      $('.rec-var-images.rec-slider').on('init', function(event, slick, currentSlide, nextSlide){
        $(this).addClass("slick-loaded");
      });

      //Variant Image Sliders
      $(".slider-pending").removeClass("slider-pending");
      $('.rec-var-images.rec-slider').slick({
        dots: false,
        arrows: true,
        adaptiveHeight: true,
        infinite: true,
        prevArrow: '<div class="rec-hidden slick-prev slick-arrow-svg"><svg width="20" height="20" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5442 1.86047L6.6582 6.97675L1.7722 1.86047" stroke="#333132" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>',
        nextArrow: '<div class="rec-hidden slick-next slick-arrow-svg"><svg width="20" height="20" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5442 1.86047L6.6582 6.97675L1.7722 1.86047" stroke="#333132" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              dots: true,
              arrows: false
            }
          }
        ]
      });

      $('.rec-var-images-modal.rec-slider').slick({
        dots: false,
        arrows: true,
        adaptiveHeight: true,
        infinite: true,
        prevArrow: '<div class="slick-prev slick-arrow-svg"><svg width="20" height="20" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5442 1.86047L6.6582 6.97675L1.7722 1.86047" stroke="#333132" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>',
        nextArrow: '<div class="slick-next slick-arrow-svg"><svg width="20" height="20" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5442 1.86047L6.6582 6.97675L1.7722 1.86047" stroke="#333132" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>'
      });

      $(".rec-variant").hover(function() {
        $(this).find(".slick-arrow-svg").removeClass("rec-hidden");
      },
      function() {
        $(this).find(".slick-arrow-svg").addClass("rec-hidden");
      });
    };

    //filtering
    /*
      START - alex customizations
      NOTE: Previously the variations displayed below the fold with Recurate coded filters.
            This was replaced by the standard color/size/condition filters in the Buy Box.
            For phase 1, I'm leaving the Recurate JS/HTML intact and am toggling/scraping it
            when the dropdowns in the Buy Box are used.
            Phase 2 should be refactoring/replacing the Recurate JS/HTML for maintainability.
    */
    var recurateUpdateVariantSelection = function(){
      // TECH DEBT - timeout is here to let the other event handler fire first that changes the 'selected' classes
      setTimeout(function(){
        var selectedSizeValue = $('.recurate-product-configurator .rec-filtering-size .dropdown__selected-dimension:not(.hidden)').data('value').replace(/"/g, '\\\"');
            selectedColorValue = $('.recurate-product-configurator .product-configurator__body .swatch--selected_pdp').data('value'),
            selectedConditionValue = $('.recurate-product-configurator .rec-filtering-condition .dropdown__selected-dimension:not(.hidden)').data('condition'),
            variantsSizeColorSelector = `.recurate-variant-list .rec-variant[data-size="${selectedSizeValue}" i][data-color="${selectedColorValue}"]`,
            variantsSelector = `${variantsSizeColorSelector}[data-condition="${selectedConditionValue}"]`,
            $atcBtn = $('.product-configurator__btn[data-product-target="cartBtn"]'),
            $conditionDesc = $('.recurate-product-configurator .condition-description')
            inStockConditions = [];

        // update hidden size field
        $('.hidden-recurate-selectedSize').val(selectedSizeValue).attr('data-value', selectedSizeValue).attr('data-name', selectedSizeValue);

        // hide all variants
        $(".recurate-variant-list .rec-variant").addClass('rec-hidden');

        // un-hide selected size
        $(variantsSelector).removeClass('rec-hidden');

        // update add-to-cart button with 1st available variant
        var selectedVariant = $(variantsSelector).first();
        if(selectedVariant.length > 0){
          var selectedVariantID = $(selectedVariant).find('.recurate-cart-add').data('id');
          $('input[name="id"]').val(selectedVariantID);
          $('product-recurate-true').data('product-selected', selectedVariantID);
          // show add to cart button
          $atcBtn.find('span').addClass('hidden');
          $atcBtn.find('span[data-product-target="cartBtnInStock"]').text($(selectedVariant).find('.recurate-cart-add').text()).removeClass('hidden');
          $atcBtn.removeClass('rw-btn--disabled').removeAttr('disabled');
          // show condition description
          $conditionDesc.html('Used Condition: ' + $(variantsSelector).find('.rec-condition-description-toggle').html());
        } else {
          //show out of stock button
          $atcBtn.find('span').addClass('hidden');
          $atcBtn.find('span[data-product-target="cartBtnOutOfStock"]').removeClass('hidden');
          $atcBtn.addClass('rw-btn--disabled').attr('disabled');
          $conditionDesc.html('');
        }

        // determine which conditions are in-stock
        $(variantsSizeColorSelector).each(function(el){
          var thisCondition = $(this).data('condition');
          if(inStockConditions.indexOf(thisCondition) === -1){
            inStockConditions.push(thisCondition);
          }
        });
        // first, make all condition dropdowns out of stock
        $('.rec-filtering-condition [data-dropdown-target="option"]').addClass('dropdown__option--sold-out');
        $('.rec-filtering-condition [data-dropdown-target="option"] .dropdown__option-message').removeClass('hidden');
        $('.rec-filtering-condition .dropdown__activator-message').removeClass('hidden');
        // $('.rec-filtering-condition [data-dropdown-target="selectedDimensions"]').removeClass('hidden');

        // update condition dropdowns with in stock/out of stock label
        for(var i=0; i<inStockConditions.length; i++){
          // $(`.rec-filtering-condition [data-dropdown-target="selectedDimensions"][data-condition="${i}"]`).removeClass('hidden dropdown__option--sold-out');
          $(`.rec-filtering-condition [data-dropdown-target="option"][data-condition="${inStockConditions[i]}"] .dropdown__option-message`).addClass('hidden');
          $(`.rec-filtering-condition [data-dropdown-target="option"][data-condition="${inStockConditions[i]}"]`).removeClass('dropdown__option--sold-out');
        }

        // update currently selected condition with out of stock label if applicable
        if(inStockConditions.indexOf($('.rec-filtering-condition .dropdown__selected-dimension:not(.hidden)').data('condition')) === -1) {
          $('.rec-filtering-condition .dropdown__activator-message').removeClass('hidden');
          $('.rec-filtering-condition').addClass('dropdown--sold-out');
        } else {
          $('.rec-filtering-condition .dropdown__activator-message').addClass('hidden');
          $('.rec-filtering-condition').removeClass('dropdown--sold-out');
        }
      }, 1);
    }
    $(`.recurate-product-configurator .rec-filtering-size [data-dropdown-target="option"],
      .recurate-product-configurator .product-configurator__body .swatch,
      .rec-filtering-condition [data-dropdown-target="option"]`).on('click', function(e){
        recurateUpdateVariantSelection();
    });
    recurateUpdateVariantSelection();
    //end - alex customizations


    // TECH DEBT - everything below here can be removed at a later date b/c the list of individual variants is no longer visible to the customer
    $('.rec-filter[data-attr="size"] li[data-val=""]').removeClass('active');
    var refilter = function() {
      $(".rec-variant-none").addClass("rec-hidden");
      $(".rec-variant").removeClass("filtered-data-size filtered-data-color filtered-data-condition");
      if($(".rec-filter li.active").length > 0) {
        $(".rec-variant").addClass('rec-hidden');
        var attr;
        $(".rec-filter").each(function() {
          attr = $(this).data('attr');
          if($(this).children("li.active").length > 0) {
            $(this).children("li.active").each(function() {
              if ($(this).data('val') == "all") {
                $(".rec-variant").addClass("filtered-" + attr);
              } else {
                $(".rec-variant["+attr+"='" + $(this).data('val') + "']").addClass("filtered-" + attr);
              }
            });
          } else {
            $(".rec-variant").addClass("filtered-" + attr);
          }
        });
        $(".rec-variant.filtered-data-size.filtered-data-color.filtered-data-condition").removeClass("rec-hidden");
        if($(".rec-variant:visible").length == 0) {
          $(".rec-variant-none").removeClass("rec-hidden");
        }
      } else {
        $(".rec-variant").removeClass('rec-hidden');
      }
      if(window.innerWidth <= 768 && $(".rec-filtering-inner").hasClass("view")) {
        $('.rec-filtering h2').click();
        window.scrollTo(0,0);
      }
    }
    let activeFilters = 0;
    $(".rec-filter").each(function() {
      $(this).children("li.active").each(function(){
        if ($(this).data('val') != 'all') activeFilters += 1;
      })
    })
    $("#filter-counter").text(activeFilters);
    $('.rec-filter li').click(function() {
        const filterHeader = this.parentElement.parentElement.children[0].children[0].children[0];

        // Remove active classlist
        if (this.dataset.val == "all") {
          Array.from(this.parentElement.children).forEach(element => {
            element.classList.remove("active")
          });
        } else {
          Array.from(this.parentElement.children).forEach(element => {
            if (element.dataset.val == "all") element.classList.remove("active")
          });
        }

        if (this.dataset.val != "all") {
          const filterCategory = this.parentElement.getAttribute('data-attr');
          let clickedFilter = this.dataset.val;

          if (filterCategory === "data-condition") {
            clickedFilter = this.innerText;
          }

          let activeFilters = filterHeader.innerText.split(", ");
          activeFilters = activeFilters.filter(filter => filter.toLowerCase() !== "all");

          if (activeFilters.includes(clickedFilter)) {
            activeFilters = activeFilters.filter(filter => filter != clickedFilter);
          } else {
            activeFilters.push(clickedFilter);
          }

          if (activeFilters.length == 0) activeFilters.push("All");
          filterHeader.innerText = activeFilters.join(", ");
        } else {
          filterHeader.innerText = this.innerText;
        }

        $(this).toggleClass("active");
        refilter();
    });
    if(window.innerWidth <= 768) {
      $('.rec-filtering h2').click(function() {
        $(".rec-filtering .collapse").toggleClass("rotate");
        $(".rec-filtering-inner").toggleClass("view");
      });
    }

    //sorting
    var resort = function(sort) {
        $('.rec-var-images.rec-slider.slick-initialized').removeClass("slick-loaded");
        $('.rec-var-images.rec-slider.slick-initialized').slick('unslick');
        $('.rec-var-images-modal.rec-slider.slick-initialized').removeClass("slick-loaded");
        $('.rec-var-images-modal.rec-slider.slick-initialized').slick('unslick');
        var divList = $(".rec-variant");
        divList.sort(function(a, b) {
          if (sort == "price-asc") {
            return $(a).data("price") - $(b).data("price")
          } else if  (sort == "price-desc") {
            return $(b).data("price") - $(a).data("price")
          } else if  (sort == "condition-desc") {
            return $(b).data("condition") - $(a).data("condition")
          } else if  (sort == "condition-asc") {
            return $(a).data("condition") - $(b).data("condition")
          }
        });
        $(".rec-variant").remove();
        $(".rec-variant-none").removeClass("rec-hidden");
        $(".rec-variants").append(divList);

        if($(".rec-variant:visible").length > 0) {
          $(".rec-variant-none").addClass("rec-hidden");
        }

        slidersInit();
        if(window.innerWidth <= 768 && $(".rec-filtering-inner").hasClass("view")) {
          $('.rec-filtering h2').click();
          window.scrollTo(0,0);
        }
    }
    $('.rec-sort li').on("click", function() {
        const sortHeader = this.parentElement.parentElement.children[0].children[0].children[0];
        const clickedSortVal = this.dataset.val;
        const clickedSortTitle = this.innerText;
        sortHeader.innerText = clickedSortTitle;

        Array.from(this.parentElement.children).forEach(element => {
          element.classList.remove("active")
        });
        this.classList.add("active");

        resort(clickedSortVal);
      });

    slidersInit();
    //simple, native add to cart functionality
    $("body").on("click", ".recurate-cart-add", function(e) {
      e.preventDefault();
      var $btn = $(this);
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: $btn.data('id'),
          quantity: 1
        },
        success: function(item) {
          if ($('.recurate-modal').hasClass('recurate-modal-active')) {
            recurateModal.close("")
          }
            document.dispatchEvent(new CustomEvent('theme:cart_drawer_open_request'));
            /*addBtn = document.querySelector('.recurate-cart-add');
            addBtn.textContent = 'Item In Cart';
            addBtn.setAttribute('disabled', '');*/
        },
        dataType: "json"
      });
    });

    //click on any actively selected variant
    //$('.variant-select.selected').click(); //function to handle logic on used collections
  };
  var recurateCollectionInit = function() {

  };

  //do we see the Recurate code? If so, init the PDP
  if($(".recurate-variant-list").length > 0) {
    recurateVariantListInit();
  } else if($(".recurate-collection-item").length > 0) {
    recurateCollectionInit();
  }

})($rec);
